/**
 * Small motion accents: Sweep (a highlight bar crossing a row at its tick),
 * Strike (a line-through that lands at its tick) and Press (the house
 * "next-up" ring on a control that gets "pressed").
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC, ReactNode } from 'react';

import { tick } from './use-motion';

export const Sweep: FC<{ at: number; tickSeconds?: number }> = ({ at, tickSeconds }) => (
  <span
    aria-hidden
    className="pointer-events-none absolute inset-y-0 left-0 w-1/3 animate-dg-tut-sweep bg-gradient-to-r from-transparent via-primary/15 to-transparent motion-reduce:hidden"
    style={tick(at, tickSeconds)}
  />
);

export const Strike: FC<{
  at: number;
  tickSeconds?: number;
  children: ReactNode;
  className?: string;
}> = ({ at, tickSeconds, children, className }) => (
  <span className={`relative inline-block ${className ?? ''}`}>
    {children}
    <span
      aria-hidden
      className="absolute left-0 top-1/2 h-px w-full origin-left animate-dg-tut-enter bg-destructive opacity-0 motion-reduce:animate-none motion-reduce:opacity-100"
      style={tick(at, tickSeconds)}
    />
  </span>
);

export const Press: FC<{
  at: number;
  tickSeconds?: number;
  children: ReactNode;
  className?: string;
}> = ({ at, tickSeconds, children, className }) => (
  <span
    className={`inline-flex rounded-md animate-dg-tut-step motion-reduce:animate-none motion-reduce:opacity-100 ${className ?? ''}`}
    style={tick(at, tickSeconds)}
  >
    {children}
  </span>
);
